const themeColors = [
    '#04aeea', // Primary blue
    '#8c65ce', // Purple
    '#e67e22', // Orange
    '#2ecc71', // Green
    '#e74c3c', // Red
    '#f39c12', // Amber
    '#16a085', // Teal
    '#9b59b6', // Violet
    '#3498db', // Light blue
    '#1abc9c', // Turquoise
    '#d35400', // Deep orange
    '#27ae60', // Emerald
    '#2980b9', // Blue
    '#8e44ad', // Dark violet
];

export const getCategoryColor = (categoryName) => {
    if (!categoryName) return themeColors[0];

    const firstLetter = categoryName.charCodeAt(0);
    const length = categoryName.length;
    const secondLetter = categoryName.length > 1 ? categoryName.charCodeAt(1) : 0;

    // simple hash
    const hash = (firstLetter * 11) + (length * 7) + (secondLetter * 5);

    // get index from our colors array
    const index = Math.abs(hash) % themeColors.length;

    return themeColors[index];
};

export default { getCategoryColor };